export const queryParamKeys = {
  submissionList: {
    sortBy: 'sortBy',
    order: 'order',
  },
};
